import React, { useState, useEffect } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  Container,
  Card,
  Typography,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  TablePagination,Select, FormControl, InputLabel
} from "@mui/material";
import {
  Search as SearchIcon,
} from "@mui/icons-material";
import BASE_URL from "../config";
const AbsentSMSPage = () => {
  const [courses, setCourses] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedClass, setSelectedClass] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [unicode, setUnicode] = useState(0); // 0 = English, 1 = Kannada
  const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState("");
  useEffect(() => {
    fetchCourses();
  }, []);
  useEffect(() => {
    if (!selectedClass) {
      setSections([]);
      setSelectedSection("");
      return;
    }
  
    // Fetch sections for the selected class
    axios.get(`${BASE_URL}/api/sections/${selectedClass}`)
      .then(res => {
        if (res.data.length > 0) {
          setSections(res.data);
        } else {
          setSections([]);
          setSelectedSection("");
        }
      })
      .catch(err => {
        console.error("Error fetching sections:", err);
      });
  }, [selectedClass]);
  const fetchCourses = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/api/coursesa`);
      setCourses(res.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };
  const fetchAcademicYears = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/academicYears/${courseID}`);
      setAcademicYears(res.data);
    } catch (error) {
      console.error("Error fetching academic years:", error);
    }
  };
  const fetchClasses = async (courseID) => {
    try {
      const res = await axios.get(`${BASE_URL}/api/classes?course=${courseID}`);
      setClasses(res.data);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const fetchStudents = async () => {
    try {
      const params = {};
      if (selectedCourse) params.courseID = selectedCourse;
      if (selectedYear) params.academicYear = selectedYear;
      if (selectedClass) params.classID = selectedClass;
      if (selectedSection) params.sectionID = selectedSection;
      if (searchName) params.studentName = searchName;
      const res = await axios.get(`${BASE_URL}/api/getStudents`, { params });
      setStudents(res.data);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };
  const handleCourseChange = (courseID) => {
    setSelectedCourse(courseID);
    setSelectedYear("");
    setSelectedClass("");
    if (courseID) {
      fetchAcademicYears(courseID);
      fetchClasses(courseID);
    } else {
      setAcademicYears([]);
      setClasses([]);
    }
  };
  const handleCheckboxClick = (id) => {
  setSelectedStudents((prev) =>
    prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id]
  );
};

const handleSelectAllClick = () => {
  if (selectedStudents.length === students.length) {
    setSelectedStudents([]);
  } else {
    const ids = students.map((s) => s.StudentID);
    setSelectedStudents(ids);
  }
};
const handleSendSMS = async () => {
  try {
    const res = await axios.post(`${BASE_URL}/api/send-absent-sms`, {
      studentIDs: selectedStudents,
      unicode, // pass language flag
    });

    alert(res.data.message || "SMS sent successfully!");
  } catch (error) {
    console.error("Error sending SMS:", error);
    alert("Failed to send SMS.");
  }
};
/* const handleExport = async () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      return;
    }

    try {
      const res = await axios.post(
        `${BASE_URL}/api/export-attendance`,
        {
          startDate: startDate.toISOString().split("T")[0],
          endDate: endDate.toISOString().split("T")[0],
        },
        { responseType: "blob" }
      );

      const fileName = `AttendanceReport_${new Date()
        .toLocaleDateString("en-GB")
        .replaceAll("/", "-")}.xlsx`;
      saveAs(res.data, fileName);
    } catch (err) {
      console.error("Export error:", err);
      alert("Failed to export report.");
    }
  }; */
  const handleExport = async () => {
  if (!startDate || !endDate || !selectedClass) {
    alert("Please select both start and end dates with class.");
    return;
  }

  const formatDate = (date) =>
    `${date.getFullYear()}-${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;

  try {
    const res = await axios.post(
      `${BASE_URL}/api/export-attendance`,
      {
        startDate: formatDate(startDate),
        endDate: formatDate(endDate),
        classn:selectedClass,
      },
      { responseType: "blob" }
    );

    const fileName = `AttendanceReport_${new Date()
      .toLocaleDateString("en-GB")
      .replaceAll("/", "-")}.xlsx`;
    saveAs(res.data, fileName);
  } catch (err) {
    console.error("Export error:", err);
    alert("Failed to export report.");
  }
};
  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Card sx={{ p: 4, boxShadow: 3 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Absent Students
        </Typography>
        {/* Filters */}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Course"
              value={selectedCourse || ""}
              onChange={(e) => handleCourseChange(e.target.value)}
            >
              <MenuItem value="">-- Select Course --</MenuItem>
              {courses.length > 0 ? (
                courses.map((course) => (
                  <MenuItem key={course.CourseID} value={course.CourseID}>
                    {course.CourseName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No courses available</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Academic Year"
              value={selectedYear || ""}
              onChange={(e) => setSelectedYear(e.target.value)}
              disabled={!selectedCourse || academicYears.length === 0}
            >
              <MenuItem value="">-- Select Academic Year --</MenuItem>
              {academicYears.length > 0 ? (
                academicYears.map((year) => (
                  <MenuItem key={year.AcademicYearID} value={year.AcademicYearID}>
                    {year.AcademicYearName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No academic years available</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              label="Select Class"
              value={selectedClass || ""}
              onChange={(e) => setSelectedClass(e.target.value)}
              disabled={!selectedCourse || classes.length === 0}
            >
              <MenuItem value="">-- Select Class --</MenuItem>
              {classes.length > 0 ? (
                classes.map((cls) => (
                  <MenuItem key={cls.id || cls.ClassID} value={cls.id || cls.ClassID}>
                    {cls.name || cls.ClassName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="" disabled>No classes available</MenuItem>
              )}
            </TextField>
          </Grid>
          {sections.length > 0 && (
  <div className="col-md-6">
    <label className="form-label">Section</label>
    <select
      className="form-select"
      value={selectedSection}
      onChange={e => setSelectedSection(e.target.value)}
    >
      <option value="">Select Section</option>
      {sections.map(sec => (
        <option key={sec.SectionID} value={sec.SectionID}>
          {sec.SectionName}
        </option>
      ))}
    </select>
  </div>
)}
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              label="Search Student Name/ID"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={fetchStudents}
              startIcon={<SearchIcon />}
            >
              Search
            </Button>
          </Grid>
          <Grid item xs={12} sm={4}>
                     <Button
  variant="contained"
  color="secondary"
  sx={{ mt: 2 }}
  disabled={selectedStudents.length === 0}
  onClick={handleSendSMS}
>
  Send Absent SMS
</Button>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                                <FormControl fullWidth>
                                  <InputLabel>SMS Language</InputLabel>
                                  <Select
                                    value={unicode}
                                    label="Language"
                                    onChange={(e) => setUnicode(Number(e.target.value))}
                                  >
                                    <MenuItem value={0}>English</MenuItem>
                                    <MenuItem value={1}>Kannada</MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                     <Grid item xs={12} sm={4}>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              dateFormat="dd-MM-yyyy"
              placeholderText="Start Date"
              className="MuiFormControl-root MuiTextField-root"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              dateFormat="dd-MM-yyyy"
              placeholderText="End Date"
              className="MuiFormControl-root MuiTextField-root"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 1 }}
              onClick={handleExport}
            >
              Export Attendance
            </Button>
          </Grid>
        </Grid>
      </Card>
      {/* Students Table */}
      <TableContainer component={Paper} sx={{ mt: 4 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976D2" }}>
            <TableRow>
                <TableCell padding="checkbox">
  <input
    type="checkbox"
    checked={
      students.length > 0 && selectedStudents.length === students.length
    }
    onChange={handleSelectAllClick}
/>
</TableCell>
              <TableCell sx={{ color: "white" }}>Student ID</TableCell>
              <TableCell sx={{ color: "white" }}>Student Name</TableCell>
              <TableCell sx={{ color: "white" }}>Course</TableCell>
              <TableCell sx={{ color: "white" }}>Academic Year</TableCell>
              <TableCell sx={{ color: "white" }}>Class</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {students.length > 0 ? (
              students
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((student) => (
                  <TableRow key={student.StudentID}>
                    <TableCell padding="checkbox">
  <input
    type="checkbox"
    checked={selectedStudents.includes(student.StudentID)}
    onChange={() => handleCheckboxClick(student.StudentID)}
  />
</TableCell>
                    <TableCell>{student.StudentID}</TableCell>
                    <TableCell>{student.StudentName}</TableCell>
                    <TableCell>{student.CourseName}</TableCell>
                    <TableCell>{student.AcademicYearName}</TableCell>
                    <TableCell>{student.ClassName}</TableCell>
                    
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No students found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={students.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </TableContainer>
    </Container>
  );
};
export default AbsentSMSPage;
